<template>
  <transition name="fade">
    <div class="popup popup__backdrop" @mousedown.self="closePopup">
      <div class="popup__content">
        <div class="reference-popup card">
          <div class="reference-popup__header card-header card-header-divider">
            <div>
              Расчет Эталона | Загрузка файла
            </div>
            <button @click="closePopup" class="reference-popup__close-btn">
              <svg fill="#3d3d3d" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="50px" height="50px">
                <path
                    d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z" />
              </svg>
            </button>
          </div>
          <div class="card-body">
            <form @submit.prevent="sendProfile" class="profile-form">
              <div class="form-item">
                <custom-input
                    name="position_for"
                    label="Рассчитывается для должности"
                    :labelWidth="40"
                    v-model="form.position_for"
                />
                <custom-select-2
                    name="calculation_period"
                    label="Выберите период расчёта"
                    :labelWidth="40"
                    :options="periodOptions"
                    v-model="form.calculation_period"
                />
              </div>
              <div class="form-item">
                <custom-file-loader
                    class="file-loader"
                    :showFileName="true"
                    name="excel-loader"
                    @loading="setFile"
                    accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                />
              </div>
              <div class="form-item">
                <button type="submit" class="btn btn-accent">Загрузить</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {
  computed,
  reactive, ref, watch,
} from "@vue/runtime-core";
import { useStore } from "vuex";
import CustomInput from "../Forms/Fields/CustomInput.vue";
import CustomFileLoader from "@/components/Forms/Fields/CustomFileLoader.vue";
import {notify} from "@kyvg/vue3-notification";
import router from "@/router";
import CustomSelect2 from "@/components/Forms/Fields/CustomSelect2.vue";
export default {
  components: {CustomSelect2, CustomFileLoader, CustomInput },
  name: "reference-upload-exel-popup>",
  props: {},
  setup(props, context) {
    const store = useStore();

    const form = ref({
      position_for: null,
      file: null,
      calculation_period: null
    });

    const periodOptions = [
      { id: 1, text: "один квартал" },
      { id: 2, text: "два квартала" },
      { id: 3, text: "три квартала" },
      { id: 4, text: "четыре квартала" },
      { id: 5, text: "более, чем четыре квартала" },
    ]

    let loadStarted = ref(false);

    const closePopup = () => {
      context.emit("close");
    };

    const excelReferencesList = computed(
        () => store.state.references.excelReferencesList
    );

    const setFile = (files) => {
      form.value.file = files[0];
    }

    const getPeriodText = (id) => {
      const selectedOption = periodOptions.find(option => option.id === id);
      return selectedOption ? selectedOption.text : null;
    };

    const sendProfile = () => {
      if (!form.value.position_for) {
        notify({
          type: "warning",
          title: "Необходимо заполнить поле 'Рассчитывается для должности'"
        });
        return;
      } else if (!form.value.file) {
        notify({
          type: "warning",
          title: "Необходимо выбрать файл",
        });
        return;
      } else if (!form.value.calculation_period) {
        notify({
          type: "warning",
          title: "Выберите период расчёта"
        });
        return;
      }

      loadStarted.value = true;
      form.value.calculation_period = getPeriodText(Number(form.value.calculation_period));

      store
          .dispatch("references/loadReferencesExcel", {
            ...form.value,
          }).then(() => {
        loadStarted.value = false;
      }).catch((error) => {
        loadStarted.value = false;
        notify({
          type: "error",
          title: error.response.data ? error.response.data.message : error,
        })
      })
    }

    watch(excelReferencesList, () => {
      router.push("/excel/references");
    })

    return {
      form,
      closePopup,
      sendProfile,
      setFile,
      periodOptions
    };
  },
};
</script>

<style lang="scss" scoped>
.popup {
  &__content {
    width: 50%;
    height: 50%;
    overflow-y: auto;
    background-color: white;
  }

  @media (max-width: 1090px) {
    &__content {
      width: 75%;
      height: 95%;
    }
  }

  @media (max-width: 425px) {
    &__content {
      width: 100%;
      height: 100%;
    }
  }
}

.reference-popup {
  background-color: white;
  width: 100%;
  min-height: 100%;
  max-height: 100%;
  margin-bottom: 0;
  border-radius: 0;

  &__header {
    flex-direction: row;
  }

  &__close-btn {
    height: 40px;
    width: 40px;

    svg {
      max-width: 100%;
    }

    &:hover svg {
      fill: var(--hover-color);
    }
  }

  &__btns {
    margin-top: 25px;

    .btn:not(:last-child) {
      margin-right: 15px;
    }
  }

  @media (max-width: 425px) {
    &__header {
      margin: 0 20px;
    }
  }
}

.popup-preloader {
  width: 100%;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
}

.form-item {
  width: 100%;
}

.file-loader {
  margin-left: -15px;
}

</style>